import { Badge } from "./Badge";
import { formatStatusLabel } from "../lib/format";
import type { ConnectionCheck } from "../types";

interface DiagnosticPanelProps {
  data: ConnectionCheck | undefined;
  isPending: boolean;
  error: unknown;
}

export function DiagnosticPanel({ data, isPending, error }: DiagnosticPanelProps) {
  return (
    <article className="panel wide" aria-labelledby="diagnosticPanelTitle">
      <div className="panel-header">
        <h2 id="diagnosticPanelTitle">Diagnostic</h2>
        <Badge
          tone={
            isPending
              ? "warn"
              : error
                ? "bad"
                : data
                  ? data.ok
                    ? "ok"
                    : "warn"
                  : ""
          }
        >
          {isPending ? "Running" : error ? "Failed" : data ? (data.ok ? "OK" : "Review") : "Idle"}
        </Badge>
      </div>
      {error ? (
        <p className="panel-error">
          {(error as Error).message ?? "Diagnostic failed."}
        </p>
      ) : null}
      {!data && !isPending && !error ? (
        <p className="muted empty-line">
          Press <strong>Run resolver diagnostic</strong> to check agency auth, routing,
          resolver readiness, and the current workflow write path without exposing tokens.
        </p>
      ) : null}
      {isPending ? (
        <p className="muted empty-line">Running read-only diagnostic…</p>
      ) : null}
      {data ? (
        <>
          <div className="checks">
            {data.checks.map((check) => (
              <div
                key={check.name}
                className={`check-row ${check.ok ? "check-ok" : "check-warn"}`}
              >
                <span className="check-icon" aria-hidden="true">
                  {check.ok ? "✓" : "!"}
                </span>
                <strong className="check-name">{formatStatusLabel(check.name)}</strong>
                <span className="check-detail">{check.detail}</span>
              </div>
            ))}
          </div>
          <p className="muted-meta" style={{ marginTop: 10 }}>
            Summary: {data.summary.active_installations} installs,{" "}
            {data.summary.active_oauth_sites} OAuth-managed sites,{" "}
            {data.summary.fallback_sites} fallback sites,{" "}
            {data.summary.credential_records} credential rows,{" "}
            {data.summary.write_ready_sites} workflow write-ready.
          </p>
        </>
      ) : null}
    </article>
  );
}
